import styled, { css } from "styled-components";
import { Button } from "components/bootstrap";
import { Select, Pagination, PageSizeSelect } from "components/common";
import GranteeIcon from "components/permissions/Grantee/GranteeIcon";
import CapabilitySelect from "./CapabilitySelect";
import EntityCreateCapabilitySelect from "./EntityCreateCapabilitySelect";
export const currentStateColor = (theme, currentState) => {
  switch (currentState) {
    case "new":
      return theme.colors.variant.lighter.success;
    case "changed":
      return theme.colors.variant.lighter.warning;
    default:
      return "transparent";
  }
};
export const GranteeListItemContainer = styled.li(
  ({ theme, $currentState }) => css`
    display: flex;
    align-items: center;
    width: 100%;
    padding: ${theme.spacings.xxs};
    border-left: ${theme.spacings.xxs} solid ${currentStateColor(theme, $currentState)};
  `
);
export const GranteeInfo = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex: 1;
    overflow: hidden;
    margin-right: ${theme.spacings.xs};
  `
);
export const GranteeListItemTitle = styled.div`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
export const StyledCapabilitySelect = styled(CapabilitySelect)`
  flex: 0.5;
`;
export const StyledEntityCreateCapabilitySelect = styled(EntityCreateCapabilitySelect)`
  flex: 0.5;
`;
export const StyledGranteeIcon = styled(GranteeIcon)(
  ({ theme }) => css`
    margin-right: ${theme.spacings.xxs};
  `
);
export const GranteeListItemActions = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.spacings.sm};
    margin-left: ${theme.spacings.xs};
  `
);
export const ShareFormSection = styled.div(
  ({ theme }) => css`
    width: inherit;
    margin-bottom: ${theme.spacings.sm};

    &:last-child {
      margin-bottom: 0;
    }
  `
);
export const GranteesSelectorHeadline = styled.h5(
  ({ theme }) => css`
    font-weight: bold;
    margin-bottom: ${theme.spacings.xs};
  `
);
export const ShareFormElements = styled.div`
  display: flex;
`;
export const ShareSubmitButton = styled(Button)(
  ({ theme }) => css`
    margin-left: ${theme.spacings.xs};
  `
);
export const GranteesSelect = styled(Select)`
  flex: 1;
`;
export const GranteesSelectOption = styled.div`
  display: flex;
  align-items: center;
`;
export const GranteeListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
`;
export const StyledGranteeList = styled.div(
  ({ theme }) => `
  >:nth-child(even) {
    background: ${theme.colors.table.row.backgroundStriped};
  };

  >:nth-child(odd) {
    background: ${theme.colors.table.row.background};
  };
`
);
export const GranteeListPaginationWrapper = styled.ul`
  display: flex;
  justify-content: center;

  .pagination {
    margin: 10px 0;
  }
`;
export const GranteeListStyledPagination = styled(Pagination)`
  margin-top: 10px;
  margin-bottom: 0;
`;
export const GranteeListStyledPageSizeSelect = styled(PageSizeSelect)(
  ({ theme }) => css`
    label {
      font-weight: normal;
      font-size: ${theme.fonts.size.body};
    }
  `
);
